var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditorRevert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 0C9.60414 0 4.02321 4.8084 2.8125 11.1429H0L3.42857 15.4286L6.85714 11.1429H4.56696C5.74242 5.74774 10.5337 1.71429 16.2857 1.71429C22.9233 1.71429 28.2857 7.07673 28.2857 13.7143C28.2857 20.3518 22.9233 25.7143 16.2857 25.7143C11.8414 25.7143 7.98027 23.309 5.90625 19.7277L4.48661 20.7054C6.87881 24.7297 11.2724 27.4286 16.2857 27.4286C23.8497 27.4286 30 21.2783 30 13.7143C30 6.15029 23.8497 0 16.2857 0ZM12 15.4286H17.1429H18V14.5714V8.57143V7.71429H16.2857V8.57143V13.7143H12",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditorRevert);
export default __webpack_public_path__ + "static/media/ImageEditorRevert.d52a639e6abfb37c7dfe0197c5824e01.svg";
export { ForwardRef as ReactComponent };